const mEditionMapEnrollmentsFamilies = {
  mEditionMapEnrollmentsFamilies: {
    alerts: {
      createAcademiaActorResetPassword: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Los datos para restablecer la contraseña fueron enviados exitosamente.'
      },

      readFamiliasExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de equipos descargado.'
      },

      updateFamiliaEstado: {
        activationSuccess: 'El equipo fue activado exitosamente.',
        deactivationSuccess: 'El equipo fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      createText: 'Crear Equipo',
      filterText: 'Filtros Avanzados'
    },

    files: {
      family: 'Equipos'
    },

    table: {
      thActive: 'Activo',
      thAdd: 'Agregar',
      thEdit: 'Editar',
      thFamily: 'Equipo',
      thShow: 'Ver',
      thStars: 'Puntaje'
    },

    tooltip: {
      add: 'Agregar Integrante',
      edit: 'Editar',
      reload: 'Actualizar',
      show: 'Ver Integrantes'
    }
  }
}

export default mEditionMapEnrollmentsFamilies
